import { HStack, VStack, Text, Anchor } from '@bpba/ui-components';
import styled from 'styled-components';
import { SvgData } from '../../model/SvgData';
import { FillSvg } from '../FillSvg';

interface IconosProps {
  iconos?: SvgData[];
}

export const Iconos = (props: IconosProps) => {
  return (
    <HStack justifyContent={'center'} flexWrap={getWrapper(props.iconos?.length)}>
      {props.iconos?.map((item, key) => {
        if (!item.titulo && !item.icono) return <></>;

        return (
          <SvgContainer key={key} height={['106px', '192px']} maxWidth={getSize(props?.iconos?.length)} marginX={['0px', null, null, '25px']}>
            <Anchor data={item} variant={'transparent'}>
              <StyledFillSvg
                height={['50px', '80px']}
                width={['50px', '80px']}
                padding={['10px', '16px']}
                margin={'auto'}
                marginBottom={['10px', '19px']}
                color="white"
                backgroundColor="primary.0"
                borderRadius={'50%'}
              >
                <div dangerouslySetInnerHTML={{ __html: item.icono }} />
              </StyledFillSvg>
              <StyledText fontSize={['14px', '22px']} lineHeight={['18px', '27px']} fontWeight={'700'} margin={'0PX'} textAlign="center">
                {item.titulo}
              </StyledText>
            </Anchor>
          </SvgContainer>
        );
      })}
    </HStack>
  );
};

export const getWrapper: any = (totalElements: number) => {
  if (!totalElements) return '';

  switch (totalElements) {
    case 1:
    case 2:
    case 3:
      return ['nowrap'];
    case 4:
      return ['wrap', 'nowrap'];
    case 5:
      return ['wrap', null, null, 'nowrap'];
  }
};

export const getSize: any = (totalElements: number) => {
  if (!totalElements) return '';

  switch (totalElements) {
    case 1:
    case 2:
    case 3:
      return ['100%', '210px', null, '182px'];
    case 4:
      return ['50%', null, '182px'];
    case 5:
      return ['33%', '210px', '182px'];
  }
};

const StyledText = styled(Text)({ whiteSpace: 'nowrap' });

const SvgContainer = styled(VStack)({
  justifyContent: 'center',
  alignItems: 'center',
});

const StyledFillSvg = styled(FillSvg)((props) => ({
  '.stroke-canales': {
    stroke: props.theme.colors.white,
    fill: 'none',
    strokeMiterlimit: 10,
    strokeWidth: '1.96px',
  },
  boxSizing: 'border-box',
}));
